import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLButtonElement> {
  static values = { text: String }

  declare textValue: string

  async copy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.textValue)
      const original = this.element.textContent
      this.element.textContent = "Copied ✓"
      this.element.disabled = true
      setTimeout(() => {
        this.element.textContent = original
        this.element.disabled = false
      }, 1500)
    } catch (err) {
      console.error("Clipboard write failed:", err)
    }
  }
}
